import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;
  fill?: string;

  [prop: string]: unknown;
}

export default ({ style, fill = 'inherit', ...rest }: IProps) => {
  const defaultStyle = { width: 20, height: 18 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height}
         viewBox="0 0 20 18" {...rest}>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M11.3864 18L18.6136 10.4485L20 9.00006L20 9.00004L20 8.99998L11.3864 0L10 1.44857L16.2702 8H0V10H16.2702L10 16.5515L11.3864 18Z"
            fill={fill} />
    </svg>
  );
};
